import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IController, IPromise} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {Debugger} from "debug";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {GruppeRessurs} from "../../../../../felles/tjenester/ressurser/GruppeRessurs";
import {gettextCatalog} from "angular-gettext";

const css = require('./visSkjermedeElementerDialog.scss');
const debug: Debugger = require('debug')('VisSkjermedeElementerDialog');

export class VisSkjermedeElementerDialog implements IController {

    static visSkjermedeElementerDialog(moete: l.MøteModell, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({moete: moete}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./visSkjermedeElementerDialog.html'),
            controller: VisSkjermedeElementerDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            Kontekst.regNavn,
            GruppeRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            regNavn.md.$mdDialog,
            VisSkjermedeElementerDialog
        ]
    }

    constructor(private kontekst: Kontekst, private gruppeRessurs: GruppeRessurs, private gettextCatalog: gettextCatalog, private $mdDialog: angular.material.IDialogService) {
    }

    moete: l.MøteModell; //settes via locals

    modell: Modell;

    lukk(){
        this.$mdDialog.hide();
    }

    $onInit(): void {
        this.initModell();
    }

    //hjelpemetoder

    private initModell() {
        this.gruppeRessurs.hent(this.moete.eiendeGruppeId).$promise
            .then(gruppe => {
                this.modell = new Modell(this.moete, gruppe.medlemmer)
            });
    }

}

class Modell{

    constructor(public moete:l.MøteModell, private medlemmer: l.GruppeMedlemListeModell[]) {
        this.utenTilgangMoete = this.somMedlemmer(this.moete.tilgang.skjerming.skjermedeMedlemmerId);
        this.skjermedeSaker = this.moete.saker
            .filter(sak => !_.isEmpty(this.somMedlemmer(sak.tilgang.skjerming.skjermedeMedlemmerId)) || sak.tilgang.skjerming.inneholderSkjermedeBarn)
            .map(sak => ({
                sak:sak,
                utenTilgang: this.somMedlemmer(sak.tilgang.skjerming.skjermedeMedlemmerId),
                skjermedeDokumenter: this.dokumenter(sak)
                    .filter(dokument =>!_.isEmpty(dokument.skjerming.skjermedeMedlemmerId))
                    .map(dokument => ({
                        dokument:dokument,
                        utenTilgang: this.somMedlemmer(dokument.skjerming.skjermedeMedlemmerId),
                    }))
            }))
    }

    utenTilgangMoete:l.GruppeMedlemListeModell[];

    skjermedeSaker: {utenTilgang:l.GruppeMedlemListeModell[]; sak:l.AgendaelementModell; skjermedeDokumenter:{utenTilgang:l.GruppeMedlemListeModell[]; dokument:l.SaksdokumentModell;}[];}[];

    private somMedlemmer(ider:string[]){
        return this.medlemmer.filter(medlem => _(ider).includes(medlem.id))
    }

    private dokumenter(sak: l.AgendaelementModell): l.SaksdokumentModell[] {
        if (!_.isArray(sak.dokumenter)) return [];
        return sak.dokumenter;
    }
}
